import {fetchAndUpdateFileLockState} from 'notebook/realtime/DocumentEditorLockReduxActions';
import {displayNotification, getDocumentUpdateToastId} from 'notebook/realtime/DocumentUpdateNotifications';
import {RealtimeMessageType} from 'realtime/Constants';

import type {DocumentUpdateMessageHandler} from './DocumentUpdateMessageHandlerConstants';

export const lockUpdateMessageHandler: DocumentUpdateMessageHandler<typeof RealtimeMessageType.LOCK_UPDATE> =
  {
    active: (fileId, {lock, userNotifications}) => {
      if (userNotifications) {
        // Reuse a single toast id per document so the "completed" (green) toast replaces the
        // "in progress" (gray) toast in place, instead of showing both at once.
        const toastId = getDocumentUpdateToastId(fileId);
        for (const notification of userNotifications) {
          displayNotification(notification, toastId);
        }
      }
      fetchAndUpdateFileLockState(fileId, lock);
    },
  };
